import React from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { Link } from "react-router-dom";
import logo from "../../images/vic-logo.svg";
import "./Footer.scss";

function Footer() {
  return (
    <>
      <div className="bottom-footer">
        <MDBContainer>
          <MDBRow className="footer-menu">
            <MDBCol
              xl="3"
              lg="3"
              md="3"
              sm="0"
              xs="0"
              className="d-none d-md-block"
            >
              <ul className="footer-menu-list">
                <li>
                  <a
                    href="https://www2.delwp.vic.gov.au/privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="footer-menu-item">Privacy </div>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www2.delwp.vic.gov.au/copyright"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="footer-menu-item">Copyright</div>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www2.delwp.vic.gov.au/disclaimer"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="footer-menu-item">Disclaimer </div>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www2.delwp.vic.gov.au/accessibility"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="footer-menu-item">
                      Accessibility Statement{" "}
                    </div>
                  </a>
                </li>
              </ul>
            </MDBCol>
            <MDBCol xl="2" lg="2" md="2" sm="0" xs="0"></MDBCol>
            <MDBCol xl="1" lg="1" md="1" sm="0" xs="0"></MDBCol>
            <MDBCol xl="2" lg="2" md="2" sm="0" xs="0"></MDBCol>
            <MDBCol xl="2" lg="2" md="2" sm="0" xs="0"></MDBCol>
            <MDBCol
              xl="2"
              lg="2"
              md="2"
              sm="12"
              xs="12"
              className="footer-logo-group"
            >
              <div className="footer-logo">
                <Link to={"/"} className="footer-logo-link nav-link">
                  <img
                    className="logo"
                    src={logo}
                    alt="State Government Logo"
                  />
                </Link>
                <p className="footer-logo-text">
                  © State Government of Victoria {new Date().getFullYear()}
                </p>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </>
  );
}

export default Footer;
